import { defineStore } from 'pinia'
import Queue from '@data/models/Queue'

const queue = new Queue()

export const useQueueStore = defineStore('queue', {
    state: () => ({
        mixes: queue ? queue.mixes : [], // array of mixes
        position: queue ? queue.position : -1, // queue position currently playing
        playlistId: queue ? queue.playlistId : null, // playlist id currently playing if any
    }),
    actions: {
        setData({ queue: next }) {
            this.mixes = next.mixes
            this.position = next.position
            this.playlistId = next.playlistId
        },
    },
})
